import { render } from "./goods-add.vue?vue&type=template&id=2cf3c15a&scoped=true"
import script from "./goods-add.vue?vue&type=script&lang=js"
export * from "./goods-add.vue?vue&type=script&lang=js"

import "./goods-add.vue?vue&type=style&index=0&id=2cf3c15a&lang=less&scoped=true"

import exportComponent from "/Users/wangdadan/IdeaProjects/LTCODE/后端管理web端/rent-admin-web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf3c15a"]])

export default __exports__